module.exports = __webpack_public_path__ + "img/armadillocomputer_1.544b4a23.gif";